
import { Chip, Pagination, Stack, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { MensajeAlertaDanger, TooltipAndIcon } from "../../components";
import { LayoutTabla } from "../../layouts";
import { useModalStore, useNotasStore } from "../../../stores";
import { fechaConHora } from "../../../helpers/prepararFecha";



const paginado = Number(process.env.REACT_APP_PAGINADO);



export const TablaNotas = ({ data, chagePage=() => {}, page=0, }) => {

    const { modalFormToggle } = useModalStore();
    const { totalNotas, setActivarNotas } = useNotasStore();

    
    const handleVerItems = (valor, tipo) => {
        setActivarNotas(valor)
        modalFormToggle(true, tipo);
    }


    return (
        <>
        {(data.length > 0)
        ?   <LayoutTabla 
                mt={3}
                paginado={
                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(totalNotas / +paginado)} disabled={Math.ceil(totalNotas / +paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'27%'}}>Fecha</TableCell>
                        <TableCell sx={{width:'23%'}}>Factura</TableCell>
                        <TableCell sx={{width:'10%'}}>Items</TableCell>
                        <TableCell sx={{width:'15%'}}>Aprobar</TableCell>
                        <TableCell sx={{width:'25%'}}>Acciones</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {data.map( ( a ) => (
                        <TableRow  key={ a.id }>
                            <TableCell>{ fechaConHora(a?.createdAt) }</TableCell>
                            <TableCell>{ a.gasto.factura }</TableCell>
                            <TableCell>{ a.gasto.items?.length }</TableCell>
                            <TableCell>
                                <Chip label={a.impactoStock ? "Sí" : "No"} size="small"
                                    color={a.impactoStock ? "success" : "error"} sx={{ color:'white' }}
                                />
                            </TableCell>
                            <TableCell>
                                <Stack direction="row" spacing={1} justifyContent="center">
                                    <TooltipAndIcon
                                        titulo="Ver Items"
                                        icono="ver"
                                        color="white"
                                        onClick={ () => handleVerItems(a, 'ver-items') }
                                    />  

                                    <TooltipAndIcon
                                        titulo="Aprobar Ingreso"
                                        icono="salida"
                                        color="white"
                                        onClick={ () => handleVerItems(a, 'aprobar-item') }
                                        disabled={a.impactoStock}
                                    />  
                                </Stack>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </LayoutTabla>
        
        :   <MensajeAlertaDanger titulo='No hay stock de productos disponible...' />
        }
        </>
    )
}